import { useRecoilValue } from 'recoil';
import { useEffect, useState } from 'react';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { styled } from 'styled-components';
import React from 'react';
import { authAtom } from '../../states/usuarios/AuthState';
import LinearProgress from '@mui/material/LinearProgress';
import { Divider, Paper, Stack, Box, Tab, Tabs } from '@mui/material';
import { IComandaEtapaReunioes, ICv, IEtapa } from '../../commons/types/crm';
import Etapa from './components/Etapas';
import { GridBackground } from '../Acoes';
import Consultor from '../Home/Components/Consultor';
import Breadcrumb from '../../components/Breadcrumb';
import CircularProgressWithLabel from '../../components/CircularProgressWithLabel';
import CircularProgressWithMultipleLabels from '../../components/CircularProgressWithMultipleLabels';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { useComandasActions } from '../../states/comandas/comandas.actions';
import { toast } from 'react-toastify';
import { useAnexosActions } from '../../states/anexos/anexos.actions';
import { useCurriculosActions } from '../../states/curriculos/curriculos.actions';
import { useTranslation } from '../../commons/useTranslasion';
import { ptBR, esES } from '@mui/material/locale';
import { useDateFormatters } from '../../utils/useDateFormatters';

const Programa: React.FC = () => {
  const { translate, language } = useTranslation();
  const { formatarData } = useDateFormatters();
  const lang = language ?? "pt-br";
  let locale = ptBR;
  switch (lang.slice(0, 2)) {
    case "es":
      locale = esES
      break;
  }
  
  const auth = useRecoilValue(authAtom);
  const comandasActions = useComandasActions();
  const anexosActions = useAnexosActions();
  const curriculosActions = useCurriculosActions();
  const [expanded, setExpanded] = useState<number>(-1);
  const [porcentagem, setPorcentagem] = useState<number>(0);
  const [tipo, setTipo] = useState<string>('');
  const [reunioes, setReunioes] = useState<IComandaEtapaReunioes[]>([]);
  const [etapas, setEtapas] = useState<IEtapa[]>([]);
  const [etapasGroup, setEtapasGroup] = useState<string[]>([]);
  const [anexos, setAnexos] = useState<any[]>([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [numeroEtapasCompletas, setNumeroEtapasCompletas] = useState(0);
  const [progressoPorTipo, setProgressoPorTipo] = useState<any[]>([]);

  const handleChangeTab = (event: any, newValue: number) => {
    setSelectedTab(newValue);
    setTipo(etapasGroup[newValue] || etapasGroup[0]);
  };

  const handleChange = (event: any) => {
    setExpanded(expanded === event ? -1 : event);
  };

  const handleChangeReload = (event: any) => {
    getComandas();
  };

  const getComandas = () => {
    comandasActions
      .list()
      .then((resp: any) => {
        setEtapas(resp.etapas);

        const newEtapasGroup = [
          ...etapasGroup,
          ...resp.etapas.map((e: IEtapa) => e.idMetodologiaNavigation?.nome),
        ];

        const uniqueEtapasGroup = Array.from(new Set(newEtapasGroup));

        const order = ['THINK', 'PLAN', 'GO TO MARKET'];
        uniqueEtapasGroup.sort((a, b) => {
          const indexA = order.indexOf(a);
          const indexB = order.indexOf(b);
          if (indexA === -1 && indexB === -1) return a.localeCompare(b);
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;
          return indexA - indexB;
        });

        setEtapasGroup(uniqueEtapasGroup);
        setTipo(uniqueEtapasGroup[0]);
        setSelectedTab(0);
        setReunioes(resp.comandaEtapaReunioes);
      })
      .catch((e: any) => {
        toast.error(e);
      });
  };

  const obterProgressoPorTipo = () => {
    const colorMap: { [key: string]: string } = {
      THINK: '#003f88',
      PLAN: '#007bff',
      'GO TO MARKET': '#00b4d8',
    };

    const progressValues = etapasGroup.map((tipo) => {
      const etapasTipo = etapas.filter((e) => e.idMetodologiaNavigation?.nome === tipo);
      const reunioesTipo = reunioes.filter((r) => etapasTipo.find((e) => e.id === r.tbEtapaId && r.status !== 'AGENDADA'));
      const porcentagemTipo = (reunioesTipo.length / etapasTipo.length) * 100;

      return {
        tipo: tipo,
        value: isNaN(porcentagemTipo) ? 0 : porcentagemTipo,
        color: colorMap[tipo] || '#003f88',
      };
    });

    setProgressoPorTipo(progressValues);
  };

  useEffect(() => {
    const r = reunioes.filter((reuniao) => reuniao.status?.toLowerCase() !== 'agendada').length;

    if (r === 0) {
      setPorcentagem(0);
      return;
    }

    setPorcentagem((r / reunioes.length) * 100);
    setNumeroEtapasCompletas(r);
    obterProgressoPorTipo();
  }, [reunioes]);

  useEffect(() => {
    anexosActions.list().then((resp: any) => {
      setAnexos(resp);
    });

    getComandas();
  }, []);

  return (
    <GridBackground container>
      <Consultor />

      <Grid item xs={12}>
        <Breadcrumb />
      </Grid>

      <Grid item xs={12} sx={{ paddingBottom: '30px' }}>
        <Typography variant="h1">{auth?.comanda?.plano}</Typography>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={4}>
            <PaperCard>
              <Typography variant="subtitle2">{translate('progressoAtual')}</Typography>
              <Typography variant="body2">
                {translate('previsaoParaConclusao')}: {formatarData(auth?.comanda?.dataFim)}
              </Typography>
              <CircularProgressWithLabel value={porcentagem} />
            </PaperCard>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <PaperCard>
              <Typography variant="subtitle2">
                {translate('etapasCompletas')}{' '}
                <span style={{ color: 'var(--gray-medium)', fontWeight: '400' }}>({translate('porTipo')})</span>
              </Typography>

              <div style={{ display: 'flex', height: '100%', alignItems: 'center' }}>
                <CircularProgressWithMultipleLabels
                  values={progressoPorTipo}
                  valorExibir={numeroEtapasCompletas}
                />
                <Stack direction="column" spacing={1} mt={2} sx={{ marginLeft: '-60px' }}>
                  {etapasGroup && progressoPorTipo &&
                    etapasGroup.map((e) => {
                      const progress = progressoPorTipo.find((p) => p.tipo === e);
                      return (
                        <Box display="flex" alignItems="center" key={e}>
                          <Box
                            width={10}
                            height={10}
                            bgcolor={progress?.color || '#003f88'}
                            borderRadius="50%"
                            mr={1}
                          />
                          <Typography variant="body2">{e}</Typography>
                        </Box>
                      );
                    })}
                </Stack>
              </div>
            </PaperCard>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <PaperCard>
              <Typography variant="subtitle2">{translate('anexos')}</Typography>
              <Box
                sx={{
                  marginTop: '20px',
                  maxHeight: '200px',
                  overflowY: 'auto',
                  '&::-webkit-scrollbar': {
                    width: '8px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#c1c1c1',
                    borderRadius: '4px',
                  },
                }}
              >
                {anexos.map((cv: any) => (
                  <>
                    <Divider />
                    <div
                      style={{
                        display: 'flex',
                        padding: '16px 24px',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Typography variant="body2">{cv.arquivo || cv.nomeCv}</Typography>

                      <Button
                        sx={{
                          height: '40px',
                          minWidth: '40px !important',
                          width: '40px !important',
                          borderRadius: '8px',
                          backgroundColor: '#EBF5FF',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <CloudDownloadIcon
                          onClick={() => {
                            window.open(cv.arquivoLink || cv.anexo, '_blank');
                          }}
                          sx={{ color: '#0D6EB3' }}
                        />
                      </Button>
                    </div>
                  </>
                ))}
              </Box>
            </PaperCard>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} sx={{ marginTop: '56px' }}>
        <Typography variant="body2">{translate('selecioneMomentoCarreira')}</Typography>
      </Grid>

      <Grid item xs={12}>
        <Grid item xs={4}>
        <DivTab style={{ width: 'auto' }}>
          <StyledTabs
            value={selectedTab}
            onChange={handleChangeTab}
            textColor="primary"
            indicatorColor="primary"
            centered
          >
            {etapasGroup &&
              etapasGroup.map((e, index) => (
                <StyledTab key={index} label={e} />
              ))}
          </StyledTabs>
        </DivTab>
        </Grid>
      </Grid>

      <Grid
        item
        direction="row"
        spacing={0}
        sx={{ display: 'flex', flexWrap: 'wrap', alignContent: 'flex-start' }}
        xs={12}
        md={12}
        lg={8}
      >
        <Grid
          container
          direction="row"
          xs={12}
          md={12}
          sx={{ display: 'flex', padding: '20px 0px' }}
        >
          <Grid container xs={12} md={12}>
            {etapas.length > 0 &&
              etapas
                .filter((c) => c.idMetodologiaNavigation?.nome === tipo)
                .map((etapa, index) => {
                  const reunioesEtapa = reunioes.filter((r) => r.tbEtapaId === etapa.id);
                  
                  return (
                    <Etapa
                      key={etapa.id}
                      etapa={etapa}
                      reunioes={reunioesEtapa}
                      index={index}
                      expanded={expanded}
                      handleChange={handleChange}
                      handleChangeReload={handleChangeReload}
                    />
                  );
                })}
          </Grid>
        </Grid>
      </Grid>
    </GridBackground>
  );
};

const PaperCard = styled(Paper)`
  background-color: var(--white-background) !important;
  border-radius: 8px !important;
  width: 384px;
  height: 273px;
  padding: 17px 16px;
`;

const StyledTab = styled(Tab)`
  height: 36px !important;
  &.Mui-selected {
    background-color: #ffffff;
    border-radius: 21px;
  }
  &.MuiTabs-indicator {
    display: none !important;
  }
`;

const StyledTabs = styled(Tabs)`
  & .MuiTabs-indicator {
    display: none;
  }
`;

const DivTab = styled.div`
  background-color: #ebf5ff;
  border-radius: 25px;
  margin-top: 16px;
  padding: 4px;
  width: 390px;
`;

export default Programa;
